/* eslint-disable no-shadow */
// eslint-disable-next-line import/prefer-default-export
export enum SearchActions {
  SEARCH = '[Search] Search',
  RESET = '[Search] Reset',
  SET_LOADING = '[Search] Set Loading',
  SET_ERROR = '[Search] Set Error',
}
